import { render, staticRenderFns } from "./PendingPaymentPage.vue?vue&type=template&id=79fb2be4&"
import script from "./PendingPaymentPage.vue?vue&type=script&lang=js&"
export * from "./PendingPaymentPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports